export default __webpack_public_path__ + "static/media/edited-13-mobile.2a24fd55.jpg";